module.exports = __webpack_public_path__ + "img/pasta.1082a0db.png";